import * as Bixby from '$/core';

export abstract class DataSiteHostService {

  public static async getAll(): Promise<Bixby.Models.DataSiteHost[]> {
    const route = Bixby.API.ServerRoute.forAction(`${Bixby.Constants.API_ADMIN_PREFIX}/${Bixby.Constants.API_DATASITEHOSTCONTROLLER}`);
    return await Bixby.API.get(route);
  }

  public static async createDataSiteHost(request: Bixby.Models.DataSiteHostRequest) : Promise<Bixby.Models.DataSiteHost[]>{
    const route = Bixby.API.ServerRoute.forAction(`${Bixby.Constants.API_ADMIN_PREFIX}/${Bixby.Constants.API_DATASITEHOSTCONTROLLER}`);
    const result: Bixby.Models.DataSiteHost[] = await Bixby.API.post(route, request);
    return result;
  }
}